import { useRef, useLayoutEffect } from "react";

type Props<T> = {
  items: T[];
  selectedItems: T[];
  checked: boolean;
};

function useCheckbox<T>({ items, selectedItems, checked }: Props<T>) {
  const checkbox = useRef<HTMLInputElement>(null);

  useLayoutEffect(() => {
    const isIndeterminate =
      selectedItems.length > 0 && selectedItems.length < items.length;

    if (checkbox.current) {
      checkbox.current.indeterminate = isIndeterminate;
      checkbox.current.checked = false;
    }
  }, [selectedItems, items.length]);

  return checkbox;
}

export default useCheckbox;
